import axios from 'axios/index';
import { encodeBase64 } from '../../utils/BubblyUtils';

function defaultLogin(userEmail, password, fbToken, googleToken, okCallback, koCallback) {
    let loginData = { user_name: userEmail, user_password: password, fbToken: fbToken, googleToken: googleToken };
    let loginAuthorizationData = encodeBase64(userEmail + ":" + password);
    let authString = "Basic " + loginAuthorizationData;

    return axios.post('/user/login', loginData,
        {
            headers: {Authorization: authString}
        })
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function defaultRegister(userData, okCallback, koCallback) {
    return axios.post('/user/register', userData)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function facebookRegister(facebookResponse, userData, okCallback, koCallback) {
    var user = {};
    user.user_agreement = userData.user_agreement;
    user.user_email = facebookResponse.email;
    user.user_fullname = facebookResponse.last_name + " " + facebookResponse.first_name;
    user.user_password = null;
    user.fbToken = facebookResponse.accessToken;

    defaultRegister(user,
        (success) => {
            defaultLogin(null, null, facebookResponse.accessToken, null, okCallback, koCallback);
        },
        (error) => {
            koCallback && koCallback('Error registering user with Facebook!');
        }
    )
}

function googleRegister(googleResponse, userData, okCallback, koCallback) {
    let user = {...userData};
    user.user_email = googleResponse.email;
    user.user_fullname = googleResponse.last_name + " " + googleResponse.first_name;
    user.user_password = null;
    user.googleToken = googleResponse.accessToken;

    defaultRegister(user,
        (success) => {
            defaultLogin(null, null, null, googleResponse.accessToken, okCallback, koCallback);
        },
        (error) => {
            koCallback && koCallback('Error occurred while trying to register user using Google!');
        }
    )
}

function sendActivationEmail(userId, okCallback, koCallback) {
    return axios.post('/user/sendActivationMail/' + userId)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function checkIfEmailIsValid(email, okCallback, koCallback) {
    return axios.get('/user/email/isValid/' + email)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function activateUser(userData, okCallback, koCallback){
    return axios.post('/user/activateUser',userData)
        .then((response) => {
            okCallback && okCallback(response);
        })
        .catch((error) => {
            koCallback && koCallback(error.response);
        });
}

function decideFacebookRegistration(facebookResponse, alreadyRegistered, userData, okCallback, koCallback) {
    if (alreadyRegistered) {
        defaultLogin(null, null, facebookResponse.accessToken, null, okCallback, koCallback);
    }
    else {
        facebookRegister(facebookResponse, userData, okCallback, koCallback);
    }
}

function decideGoogleRegistration(googleResponse, alreadyRegistered, userData, okCallback, koCallback) {
    if (alreadyRegistered) {
        defaultLogin(null, null, null, googleResponse.accessToken, okCallback, koCallback);
    }
    else {
        googleRegister(googleResponse, userData, okCallback, koCallback);
    }
}

function goBackAfterTimeout(history) {
    window.setTimeout(() => {
        history.goBack();
    }, 5000);
}

function sendPasswordResetEmail(email, okCallback, koCallback) {
    return axios.get('/login/password/' + email)
        .then(response => {
            okCallback && okCallback(response)
        })
        .catch(err => {
            koCallback && koCallback(err)
        })
}

function checkHashIsValid(userId, hash, okCallback, koCallback) {
    return axios.post('/login/checkHash/' + userId + '/' + hash)
        .then(response => {
            okCallback && okCallback(response)
        })
        .catch(err => {
            koCallback && koCallback(err)
        })
}

function changePassword(userId, password,fingerprint, hash, okCallback, koCallback) {
    const payload = {
        user_password_new: password,
        user_password_reset_hash: hash,
        user_fingerprint : fingerprint
    }

    return axios.post('/login/changePassword/' + userId, payload)
        .then(response => {
            okCallback && okCallback(response)
        })
        .catch(err => {
            koCallback && koCallback(err)
        })
}

function getUserEmail(userId,okCallback, koCallback){
    return axios.get('/user/getEmail/' + userId)
        .then(response =>{
            okCallback && okCallback(response)
        })
        .catch(err => {
            koCallback && koCallback(err)
        })
}

function sendContactEmail(payload, okCallback, koCallback){
    axios.post('/user/contactUs/', payload)
        .then(response =>
            okCallback && okCallback(response)
        )
        .catch(response =>
            koCallback && koCallback(response)
        );
}

export default { defaultLogin, defaultRegister, sendActivationEmail, checkIfEmailIsValid, activateUser, decideFacebookRegistration, decideGoogleRegistration, goBackAfterTimeout, sendPasswordResetEmail , checkHashIsValid, changePassword,getUserEmail,sendContactEmail } ;
